import React from 'react';
import logoLight from '../assets/nubiecloud-logo-light.png';
import logoDark from '../assets/nubiecloud-logo-dark.png';

interface LogoProps {
  size?: 'small' | 'medium' | 'large' | 'xl';
  className?: string;
  showTagline?: boolean; // kept for API compatibility
  darkMode?: boolean;    // kept for API compatibility
}

const Logo: React.FC<LogoProps> = ({ size = 'medium', className = '' }) => {
  const sizeClasses = {
    small: 'h-10',
    medium: 'h-16',
    large: 'h-20',
    xl: 'h-32'
  };

  // Two theme variants of the NubieCloud lockup (orange mark + wordmark).
  // The wordmark is dark on light surfaces, white on dark surfaces; the mark
  // stays brand orange. Visibility is toggled by the .dark class on <html>.
  return (
    <div className={`flex flex-col items-center ${className}`}>
      <img
        src={logoLight}
        alt="NubieCloud"
        className={`${sizeClasses[size]} w-auto object-contain block dark:hidden`}
      />
      <img
        src={logoDark}
        alt="NubieCloud"
        className={`${sizeClasses[size]} w-auto object-contain hidden dark:block`}
      />
    </div>
  );
};

export default Logo;
